module.exports = __webpack_public_path__ + "static/media/8.7cbf5c87.jpg";